export const ListQueryKey = 'roles';
export const DetailQueryKey = 'role';

export const Urls = {
  selectUrl: '/privileges/role/list',
  updateUrl: '/privileges/role/update',
  deleteUrl: '/privileges/role/delete',
  createUrl: '/privileges/role/create',
  detailUrl: '/privileges/role/detail',
};
